const adminStatusText = {
  apply: '申請中',
  approval: '承認済',
  notapproval: '非承認',
  reapply: '再申請',
  notreport: '開催報告未',
  fin: '開催報告済'
}
const lecturerStatusText = {
  draft: '下書き',
  apply: '申請中',
  approval: '掲載中',
  notapproval: '要修正',
  reapply: '再申請',
  notreport: '要開催報告',
  fin: '開催報告済'
}

const eventKindText = {
  event: 'イベント',
  photo: '撮影会',
  school: '教室'
}

const eventKindFromPath = function (context) {
  return context.$route.path.replace(/\/(\w+)\/.+/, '$1')
}

const eventKindTextFromPath = function (context) {
  let kind = eventKindFromPath(context)
  return eventKindText[kind]
}

const parseDateToSendAPI = function (dataStr) {
  return dataStr.replace(/-/g, '/')
}

const fullAddress = function (v) {
  return v
  ? ['〒' + v.zipcode, v.prefecture, v.city, v.address1, v.address2].join(' ')
  : ''
}

const fullAddressWithName = function (v) {
  let address = fullAddress(v)
  return address
  ? [address, v.venue_name].join(' ')
  : ''
}

const zeroPadding = function (num, digits) {
  return new Intl.NumberFormat('ja-JP', { useGrouping: false, minimumIntegerDigits: digits })
    .format(num)
}

const hasEventNo = function (eventNo) {
  return eventNo !== 0
}

const detailsComputed = function (name) {
  return {
    statusText () {
      let base = this.$router.options.base
      if (base === '/lecturer') {
        return lecturerStatusText[this[name].status]
      } else if (base === '/admin') {
        return adminStatusText[this[name].status]
      } else {
        return ''
      }
    },
    fullAddress: function () {
      return fullAddressWithName(this[name].venue)
    },
    venue () {
      return this[name].venue
    },
    venueName () {
      return this.venue ? this.venue.venue_name : ''
    },
    homepage () {
      return this.venue ? this.venue.homepage : ''
    },
    inquiry () {
      return this[name].inquiry
    },
    tel () {
      return this.inquiry ? this.inquiry.tel : ''
    },
    email () {
      return this.inquiry ? this.inquiry.email : ''
    },
    lecturerName () {
      let lecturerName = this[name].lecturer_name
      return lecturerName + (this.endsWith(lecturerName, '先生') ? '' : ' 先生')
    },
    images () {
      return this[name] && this[name].images ? this[name].images : []
    },
    eventNo: function () {
      return hasEventNo(this[name].event_no) ? zeroPadding(this[name].event_no, 5) : ''
    },
    eventDatePublicMulti: function () {
      return this[name].event_date_public_multi.replace(',', '\n')
    },
    visibleApplyDate () {
      let base = this.$router.options.base
      if (base === '/admin' && this.item.apply_date !== '') {
        return ['apply', 'reapply'].some(s => s === this.item.status)
      } else {
        return false
      }
    },
    formatedApplyDate () {
      return formatApplyDate(this.item)
    },
    formatedApplyDatePassed () {
      return formatApplyDatePassed(this.item)
    }
  }
}

const formatApplyDate = (obj) => {
  return obj.apply_date + '（' + getWeekdayLabel(obj.apply_date) + '）'
}

const formatApplyDatePassed = (obj) => {
  if (obj.apply_date_passed === 0) {
    return '本日'
  } else if (obj.apply_date_passed < 0) {
    return ''
  } else {
    return obj.apply_date_passed + '営業日前'
  }
}

const getWeekdayLabel = (obj) => {
  // ignore timezone
  return ['日', '月', '火', '水', '木', '金', '土'][new Date(obj).getDay()]
}

const defaultLecturerStatus = 99
const lecturerStatusesMap = {
  10: 'マスター講師',
  20: '殿堂入りアーティスト',
  30: 'アーティスト',
  50: 'プロフォトグラファー',
  55: 'プロティーチャー',
  60: 'フォトグラファー',
  70: 'おすわりアート',
  80: 'コラージュ対応可',
  110: 'STORYカメラマン',
  120: 'STORYアシスタント'
}

const lecturerStatusesText = (statusList) => {
  return statusList.map((status) => lecturerStatusesMap[status])
}

const isArray = (obj) => {
  return Object.prototype.toString.call(obj) === '[object Array]'
}

const isFile = (obj) => {
  return Object.prototype.toString.call(obj) === '[object File]'
}

const removeEmptyKey = (obj) => {
  Object.keys(obj).filter(k => obj[k] === '').forEach(k => {
    delete obj[k]
  })
  return obj
}

const startsWith = function (str, prefix) {
  return str.slice(0).indexOf(prefix) === 0
}

const endsWith = function (str, suffix) {
  let sub = str.length - suffix.length
  return (sub >= 0) && (str.lastIndexOf(suffix) === sub)
}

const isDate = function (dateStr) {
  let y = parseInt(dateStr.substr(0, 4))
  let m = parseInt(dateStr.substr(5, 2)) - 1
  let d = parseInt(dateStr.substr(8, 2))
  let dt = new Date(y, m, d)
  return (y === dt.getFullYear() && m === dt.getMonth() && d === dt.getDate())
}

const maxDate = function (l) {
  if (!isArray(l)) {
    return
  }

  // コピーしたリストの中の最大値を返す
  return Math.max.apply(null, l)
}

const toStringFromDateString = function (dateString) {
  if (dateString === '') {
    return
  }

  try {
    let d = new Date(dateString)
    return [
      d.getFullYear(),
      ('0' + (d.getMonth() + 1)).slice(-2),
      ('0' + d.getDate()).slice(-2)
    ].join('/')
  } catch (Error) {
    return ''
  }
}

const stringToDate = function (dateString) {
  var arr = dateString.split('/')
  return new Date(arr[0], arr[1] - 1, arr[2])
}

export default {
  adminStatusText,
  lecturerStatusText,
  eventKindText,
  eventKindFromPath,
  eventKindTextFromPath,
  // parseDateToBindForm,
  parseDateToSendAPI,
  fullAddress,
  fullAddressWithName,
  detailsComputed,
  lecturerStatusesMap,
  defaultLecturerStatus,
  lecturerStatusesText,
  isArray,
  isFile,
  removeEmptyKey,
  startsWith,
  endsWith,
  isDate,
  zeroPadding,
  hasEventNo,
  maxDate,
  toStringFromDateString,
  stringToDate,
  formatApplyDate,
  formatApplyDatePassed
}



// WEBPACK FOOTER //
// ./src/util/common.js